import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import { baseUrl, userLocation, ipAddress, userName } from '../Univ.js';

function EditShift() {
  const { id } = useParams();
  const [shiftName, setShiftName] = useState('');

  const [registerData, setRegisterData] = useState({
    monday_in_time: null,
    monday_out_time: null,
    tuesday_in_time: null,
    tuesday_out_time: null,
    wednesday_in_time: null,
    wednesday_out_time: null,
    thursday_in_time: null,
    thursday_out_time: null,
    friday_in_time: null,
    friday_out_time: null,
    saturday_in_time: null,
    saturday_out_time: null,
    sunday_in_time: null,
    sunday_out_time: null
  });

  useEffect(() => {
    try {
      axios.get(baseUrl + 'shift-view/' + id + "/")
        .then(function (response) {
          setRegisterData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, [id]);

  useEffect(() => {
    // Set the initial value when the component mounts
    setShiftName(registerData.shift_name || '');
  }, [registerData]);

  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const handleChange = (day, field, value) => {
    setRegisterData(prevData => ({
      ...prevData,
      [`${day}_${field}`]: value
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('shift_name', shiftName);
    daysOfWeek.forEach(day => {
      formData.append(`${day}_in_time`, registerData[`${day}_in_time`]);
      formData.append(`${day}_out_time`, registerData[`${day}_out_time`]);
    });
    formData.append('addedby', userName);
    formData.append('ip_add', ipAddress);
    formData.append('location', userLocation);

    axios.put(baseUrl + 'shift-view/' + id + '/', formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          console.log('Form submitted successfully!', response.data);
          Swal.fire({
            title: 'Shift List Edited successfully',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false
          });
          setTimeout(() => {
            window.location.href = '/add-shift';
          }, 3000);
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to Edit. Please try again later.',
          'error'
        );
      });
  };

  return (
    <section className="container mt-4">
      <div className="table-responsive">
        <div className='card'>
          <h4 className='card-header text-center'
            style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="fa-solid fa-clock" aria-hidden="true" style={{ color: 'red' }}></i>
            Shift List
          </h4>
          <div className='card-body'>
            <form>
              <div className="row mt-4">
                <div className="col-md-2 mb-3">
                  <label htmlFor="Shift Name" className="form-label">Shift Name:</label>
                </div>
                <div className="col-md-2 mb-3">
                  <input
                    type="text"
                    name="shiftName"
                    value={shiftName}
                    onChange={(e) => setShiftName(e.target.value)}
                  />
                </div>
              </div>

              <div className="row mt-4">
                {daysOfWeek.map(day => (
                  <React.Fragment key={day}>
                    <div className="col-md-12 mb-3 d-flex align-items-center">
                      <label htmlFor={day} className="form-label me-3" style={{ minWidth: '80px' }}>
                        {day.charAt(0).toUpperCase() + day.slice(1)}:
                      </label>
                      <TextField
                        type="time"
                        label="In-Time"
                        value={registerData[`${day}_in_time`] || ''}
                        onChange={(e) => handleChange(day, 'in_time', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }} // 5 min
                        className="me-3"
                      />
                      <TextField
                        type="time"
                        label="Out-Time"
                        value={registerData[`${day}_out_time`] || ''}
                        onChange={(e) => handleChange(day, 'out_time', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }} // 5 min
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>

              <div className="row">
                <div className="col-md-12 text-center mb-5">
                  <button type="button" onClick={submitHandler}
                    className="btn btn-success">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditShift;
